
export const createCell = () => {
  let newcol = {
    type: 'td', attrs: {}, children: [{ text: '' }]
  }
  return JSON.parse(JSON.stringify(newcol))
}
